module.exports = __webpack_public_path__ + "static/media/TIMES.TTF-16-Regular.c3a696af.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./fonts/TIMES.TTF-16-Regular.woff
 ** module id = 10
 ** module chunks = 0
 **/